/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const storeLocatorSideListElementSX: SxProps = {
	width: '100%',
	whiteSpace: 'nowrap',
};

export const allStoresListSX: SxProps = {
	fontSize: '20px',
	fontFamily: 'mikado-regular,Effra, Helvetica, sans-serif',
	fontWeight: 700
}